import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const RemovedFromPortalUserTooltip = ({
  children
}) => /*#__PURE__*/_jsx(Tooltip, {
  placement: "top",
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "routing-ui.routingRules.users.removedFromPortal"
  }),
  children: children
});
RemovedFromPortalUserTooltip.displayName = 'RemovedFromPortalUserTooltip';
export default RemovedFromPortalUserTooltip;